import { Link } from "react-router-dom";
import { AppTopBar } from "@/components/AppTopBar";
import { WalletMovementPanel } from "./WalletMovementPanel";
import WalletAdjustmentPanel from "./WalletAdjustmentPanel";

export default function FinanceWalletMovement() {
  return (
    <div className="app-shell">
      <AppTopBar active="accounts" />
      <main className="content">
        <Link to="/accounts" className="back-link" data-testid="back-to-finance">← Dashboard Keuangan</Link>
        <div style={{ margin: "10px 0 16px" }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Mutasi Wallet Manual</h1>
          <p className="hint" style={{ margin: "4px 0 0" }}>
            Catat penyesuaian saldo wallet marketplace yang benar-benar terjadi di luar settlement.
          </p>
        </div>
        <WalletMovementPanel />
        <WalletAdjustmentPanel />
      </main>
    </div>
  );
}
